// autogenerated file
import withoutCookiePolicy from './withoutCookiePolicy'
export default withoutCookiePolicy
